// 公共变量
// const ajaxBaseUrl = '/api';
const ajaxBaseUrl = '/test/api'; // 测试环境
export default {
  ajaxBaseUrl,
  tokenId: 'dl_tokenId_bl', // 自定义tokenId  -- localhost 存储tokenId名称
  imageSrcPrefix: `${ajaxBaseUrl}/platform/system/sysFile/getFileById.ht?fileId=`,
  contractImageSrc: `${ajaxBaseUrl}/mobile/item/pdfSignatureController/readContract.ht?identify=`,
  contractImageSrcBl: `${ajaxBaseUrl}/mobile/item/pdfSignatureController/blReadContract.ht?identify=`
};



// WEBPACK FOOTER //
// ./src/config.js